import React from 'react';
import Carousel from './Carousel';

import DestinationSection from '../pages/DestinationSection';
import DestinationGallery from '../pages/DestinationGallery';
import ServicesArea from '../pages/ServicesArea';
import TourPackages from '../pages/TourPackages';
import TravelGuides from '../pages/TravelGuides';
import TestimonialSection from '../pages/TestimonialHome';
import InstagramSection from '../pages/InstagramSection';
import AboutSection from '../pages/Servicehome';
import ServicesSection from '../pages/AwardsSection';



const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">



        <Carousel/>
        <DestinationSection/>
        <DestinationGallery/>
   
        <ServicesArea/>
    
        <ServicesSection/>
        <TourPackages/>
        
        <AboutSection/>
        <TravelGuides/>
        <TestimonialSection/>
        <InstagramSection/>
    </div>
  );
};

export default HeroSection;
